import { importProvidersFrom } from '@angular/core';
import CookieConfig from '@app/common/cookieConsent';
import { environment } from '@env/environment';
import { NgbModule, NgbCarouselModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RECAPTCHA_V3_SITE_KEY, ReCaptchaV3Service, RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AvatarModule } from 'ngx-avatars';
import { KINNECT_AVATAR_PASTEL_COLORS } from '@app/shared/kinnect-avatar';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { ImgFallbackModule } from 'ngx-img-fallback';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MomentModule } from 'ngx-moment';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule, NgxUiLoaderService } from 'ngx-ui-loader';
// etc...

export const thirdPartyProviders = [
  importProvidersFrom(
    NgxUiLoaderModule,
    NgbModule,
    NgbCarouselModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ImgFallbackModule,
    PdfViewerModule,
    CarouselModule,
    AvatarModule.forRoot({ colors: [...KINNECT_AVATAR_PASTEL_COLORS] }),
    InfiniteScrollModule,
    MomentModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-left',
      preventDuplicates: true,
    }),
    NgcCookieConsentModule.forRoot(CookieConfig),
  ),
  { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha_siteKey },
  ReCaptchaV3Service,
  NgxUiLoaderService,
  NgbActiveModal,
];